
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const sens: Operator = {
	id: 'sens',
	name: 'Sens',
	role: 'Attacker',
	org: 'SFG',
	squad: 'WOLFGUARD',
	ratings: {
		health: 1,
		speed: 3,
		difficulty: 2
	},
	meta: {
		gender: 'o',
		country: 'be',
		season: 'Y7S2',
		height: 178,
		weight: 73,
		price: {
			renown: 15000,
			r6credits: 360
		}
	},
	bio: {
		real_name: 'Néon Ngoma Mutombo',
		birthplace: 'Brussels, Belgium'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#59bda5"></path><path d="M73 73v48.667L101.333 73zm37.111 0L73 136.778v48.111L145.556 73zm81.306 0-10.083-11-21.222 5.556L73 192.944V277h23.667l15.5-12.083-38.083-55.625 102.11-133.514 33.76 41.323-1.704 6.711-31.75-39.2-84.562 113.68 38.84 52.542 54-39.444-3.222 12.444-36.222 49.056 24.556 40.344 98.694-114.931-36.863-45.513 5.63-2.155L277 199.167V73zm-27.861 93.722L106.625 198.5l56.931-76.111zm94.173 31.736-80.979-33.417v-64l28.779 34.62-3.695 13.421 10.504-5.231 8.221 9.889-15.142 8.26.958.542 16.379-6.157zM277 277v-60.167L232.542 277z"></path><path d="m73 154 33.056-52.25v9.944L73 163.806zm32.792 123 71.791-55.292-43.5 55.292zm133.125 0L277 224.833v8.5L244.25 277zM201 157.25l.833-8.167 41.75-85.916 23-12.25-55 89.666L277 50.333v33.75zm4.417 4.75 9-9.667L277 102.417l-24.833 37.666zM73 238.292l24.352 38.174-.685.534h-4L73 246.521z" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-sens'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
